/**
 * Admin Bookings → Operations inquiry trace deep-link helpers.
 */

export const ADMIN_TRACE_INQUIRY_ID_PARAM = 'traceInquiryId';
export const ADMIN_INQUIRY_TRACE_FOCUSED_ROW_TEST_ID = 'admin-inquiry-trace-focused-row';
export const ADMIN_BOOKING_TRACE_BTN_TEST_ID_PREFIX = 'admin-booking-trace-';

export function adminBookingTraceBtnTestId(inquiryId) {
  return `${ADMIN_BOOKING_TRACE_BTN_TEST_ID_PREFIX}${inquiryId}`;
}

export function parseTraceInquiryIdFromSearchParams(searchParams) {
  const value = searchParams?.get?.(ADMIN_TRACE_INQUIRY_ID_PARAM);
  if (!value) {
    return '';
  }
  return String(value).trim();
}

export function buildAdminOpsTraceSearchParams(inquiryId) {
  const params = new URLSearchParams();
  params.set('tab', 'ops');
  if (inquiryId) {
    params.set(ADMIN_TRACE_INQUIRY_ID_PARAM, String(inquiryId).trim());
  }
  return params;
}

export function buildAdminTraceUrl(inquiryId) {
  const params = buildAdminOpsTraceSearchParams(inquiryId);
  return `/admin?${params.toString()}`;
}
